import { render, staticRenderFns } from "./BrandSideBar.vue?vue&type=template&id=e32a1fda&scoped=true&"
import script from "./BrandSideBar.vue?vue&type=script&lang=js&"
export * from "./BrandSideBar.vue?vue&type=script&lang=js&"
import style0 from "./BrandSideBar.vue?vue&type=style&index=0&id=e32a1fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32a1fda",
  null
  
)

export default component.exports